import { render, staticRenderFns } from "./enter-piece-pop.vue?vue&type=template&id=20fad05a&scoped=true&"
import script from "./enter-piece-pop.vue?vue&type=script&lang=js&"
export * from "./enter-piece-pop.vue?vue&type=script&lang=js&"
import style0 from "./enter-piece-pop.vue?vue&type=style&index=0&id=20fad05a&lang=stylus&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "20fad05a",
  null
  
)

export default component.exports